import sol_data from '@/store/solutions/sol_data'
import sol_detail from '@/store/solutions/sol_detail'
import sol_filters from '@/store/solutions/sol_filters'
import sol_view from '@/store/solutions/sol_view'
// import sol_customSols from '@/store/solutions/sol_customSols'
// import study from '@/store/solutions/solutions'

const getInitialState = ({ namespace }) => ({
  sol_namespace: namespace, // TODO theres another namespace in sol_customSol named sol_namespace
  ...sol_data.state,
  ...sol_detail.state,
  ...sol_filters.state,
  ...sol_view.state,
})

function getSolutionsModule(namespace) {
  return {
    state: getInitialState({ namespace }),
    getters: {
      ...sol_data.getters,
      ...sol_detail.getters,
      ...sol_filters.getters,
      ...sol_view.getters,
      // ...sol_customSols.getters,
      // ...study.getters,
    },
    actions: {
      ...sol_data.actions,
      ...sol_detail.actions,
      ...sol_filters.actions,
      ...sol_view.actions,
      // ...sol_customSols.actions,
      // ...study.actions,
    },
    mutations: {
      ...sol_data.mutations,
      ...sol_detail.mutations,
      ...sol_filters.mutations,
      ...sol_view.mutations,
      // ...sol_customSols.mutations,
      // ...study.mutations,
    },
  }
}

export { getSolutionsModule }
